import { AxiosPromise } from 'axios';

import { client } from './client';

export class requestApi {
  static create(data: { name: string; contact: string }): AxiosPromise {
    return client.post('/callme', data).catch(Promise.reject);
  }
}
